const e=t=>typeof t=="object"&&"type"in t&&t.type==="rgb";export{e as isRicosPaletteRgb};
//# sourceMappingURL=identifiers.js.map
